export default {"src":"/_next/static/media/delmonte.b60180e1.svg","height":39,"width":54,"blurWidth":0,"blurHeight":0};